/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Picker_Hint_SingleInputs */

const vi_media_picker_hint_single = /** @type {(inputs: Media_Picker_Hint_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm một ảnh để chọn, hoặc Tải lên ảnh mới từ máy.`)
};

/**

* @param {Media_Picker_Hint_SingleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_picker_hint_single = /** @type {((inputs?: Media_Picker_Hint_SingleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Picker_Hint_SingleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_picker_hint_single(inputs)
});